import { GetQuoteFieldValueFn } from "Quoting/components/hooks/useHandleQuoteFieldChange";

// default values of reduction details
export const reductionDetailsDefaults = Object.freeze({
  hipStandardBenefitAmount: 2000,
  kneeNoPatellaStandardBenefitAmount: 800,
  footBonesStandardBenefitAmount: 800,
  ankleStandardBenefitAmount: 800,
  wristStandardBenefitAmount: 700,
  elbowStandardBenefitAmount: 600,
  shoulderGlenohumeralStandardBenefitAmount: 400,
  handBonesStandardBenefitAmount: 300,
  collarboneAcromioclavicularStandardBenefitAmount: 300,
  twoOrMoreFingersStandardBenefitAmount: 140,
  twoOrMoreToesStandardBenefitAmount: 140,
  oneFingerOrToeStandardBenefitAmount: 60,
  kneecapStandardBenefitAmount: 100,
  lowerJawStandardBenefitAmount: 200,
  otherDislocationStandardBenefitAmount: 60,
});

// default values of fracture details
export const fractureDefaultValues = Object.freeze({
  hipThighFemurFractureAmount: 2000,
  skullFractureNonDepressedAmount: 1900,
  pelvisFractureAmount: 2000,
  armBetweenShoulderAndElbowFractureAmount: 1100,
  shoulderBladeFractureAmount: 1100,
  legFractureAmount: 1100,
  ankleFractureAmount: 800,
  kneecapFractureAmount: 800,
  collarBoneFractureAmount: 800,
  forearmFractureAmount: 800,
  footFractureAmount: 700,
  handOrWristFractureAmount: 700,
  lowerJawFractureAmount: 400,
  twoOrMoreRibsFingersToesFractureAmount: 300,
  bonesOfFaceFractureAmount: 300,
  noseFractureAmount: 300,
  oneRibFingerToeFractureAmount: 140,
  coccyxFractureAmount: 140,
  skullFractureDepressedAmount: 2000,
  vertebralBodyFractureAmount: 1500,
  vertebralProcessFractureAmount: 1500,
  upperJawFractureAmount: 300,
  sternumFractureAmount: 300,
  anyOtherFractureAmount: 140,
});

export const unitsOptions = [
  {displayValue: '2', code: '2', orderNo: 0},
  {displayValue: '3', code: '3', orderNo: 1},
  {displayValue: '4', code: '4', orderNo: 2},
];

export const handleRestrictPlanOptions = (numOfPlans: number, getQuoteFieldValue: GetQuoteFieldValueFn,) => {
    const restrictedPairs = [[0,2]];
    if(numOfPlans > 1) {
      let planOptions: any[] = unitsOptions;
      for (let i = 0; i < numOfPlans; i++) {
        const firstPlanOption = getQuoteFieldValue<number>(`benefitPackagingDetail.plans[${i}].coverageDefs[0].benefitStructure.unitsOfAccidentFacilityCare`);
        const firstPlanOptionOrderNo = unitsOptions.find(item => Number(item.code) === firstPlanOption).orderNo;
        for (const pair of restrictedPairs) {
          if(firstPlanOptionOrderNo === pair[0]) {
            planOptions = unitsOptions.filter(item => item.orderNo !== pair[1]);
          }
          else if(firstPlanOptionOrderNo === pair[1]) {
            planOptions =  unitsOptions.filter(item => item.orderNo !== pair[0]);
          }
        }
      }
      return planOptions;
    }
    else {
      return unitsOptions;
    }
  }

export const getOptionFromValue = (value: string) => [{displayValue: value, code: value, orderNo: 0}];

export const getOptionFromValueTimePeriod = (value: string) => [
  {displayValue: 'Covered Accident', code: value, orderNo: 0},
];

export const getOptionFromValueTimePeriodHSS = (value: string) => [
  {displayValue: 'Calender Year', code: 'CalendarYear', orderNo: 0},
];

export const getOptionFromValueOrganizedSportsActivityBenefitPct = (value: string) => [
  {displayValue: '25%', code: '0.25', orderNo: 0},
];

export const dependentChildOfDislocationRider = 1;
export const brainInjuryDiagnosisDetailsMaxBenefitNumber = 1;
export const brainInjuryDiagnosisDetailsTimePeriodCd = 'Covered Accident';
export const brokenToothDetailsMaxBenefitNumber = 1;
export const brokenToothDetailsTimePeriodCd = 'Covered Accident';
export const defaultMaxClosed = 2000;
export const defaultMaxOpen = 6000;
export const majorDiagnosticExamDetailsTimePeriodCd = 'CoveredAccident';
export const lacerationLengthMaxBenefitNumber = 1;
export const burnDegreeBenefitAmount= 2000;
export const openAbdominalOrThoracicSurgeryDetailsBenefitAmount = 1000;